var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#7692FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26V25.06C22.0003 24.4714 22.1972 23.8998 22.5596 23.4359C22.922 22.9721 23.429 22.6427 24 22.5C24.571 22.3573 25.078 22.0279 25.4404 21.5641C25.8028 21.1002 25.9997 20.5286 26 19.94V18.93C26 16.76 24.206 15 22.034 15C19.826 15 18 16.79 18 19M35 22C35 25.4478 33.6304 28.7544 31.1924 31.1924C28.7544 33.6304 25.4478 35 22 35C18.5522 35 15.2456 33.6304 12.8076 31.1924C10.3696 28.7544 9 25.4478 9 22C9 18.5522 10.3696 15.2456 12.8076 12.8076C15.2456 10.3696 18.5522 9 22 9C25.4478 9 28.7544 10.3696 31.1924 12.8076C33.6304 15.2456 35 18.5522 35 22ZM22 28.5H22.01V28.51H22V28.5ZM22.5 28.5C22.5 28.6326 22.4473 28.7598 22.3536 28.8536C22.2598 28.9473 22.1326 29 22 29C21.8674 29 21.7402 28.9473 21.6464 28.8536C21.5527 28.7598 21.5 28.6326 21.5 28.5C21.5 28.3674 21.5527 28.2402 21.6464 28.1464C21.7402 28.0527 21.8674 28 22 28C22.1326 28 22.2598 28.0527 22.3536 28.1464C22.4473 28.2402 22.5 28.3674 22.5 28.5Z",
    stroke: "#FEFCFD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.20626706477e570f8079399491c79897.svg";
export { ForwardRef as ReactComponent };